import { useCallback, useEffect, useRef } from "react";

// Touch equivalent of a right-click: fires `onLongPress({ x, y })` after
// `delay` ms of a still touch/pen contact. Mouse pointers are ignored (they
// have a real contextmenu event). Any movement, release or cancel aborts.
export default function useLongPress(onLongPress, { delay = 500, enabled = true } = {}) {
  const timer = useRef(null);

  const clear = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
  }, []);

  useEffect(() => clear, [clear]);

  const onPointerDown = useCallback(
    (event) => {
      if (!enabled || event.pointerType === "mouse") return;
      const { clientX: x, clientY: y } = event;
      clear();
      timer.current = setTimeout(() => {
        timer.current = null;
        onLongPress({ x, y });
      }, delay);
    },
    [enabled, delay, onLongPress, clear]
  );

  return {
    onPointerDown,
    onPointerUp: clear,
    onPointerMove: clear,
    onPointerCancel: clear,
    onPointerLeave: clear,
  };
}
